const stripUmlauts = str => {
    return str.toLowerCase().replace(/ä/, 'ae').replace(/ö/, 'oe').replace(/ü/, 'ue');
};

export async function fetchCountries(apiBaseUrl: string, language: string): Promise<[]> {
    return await fetch(
        `${apiBaseUrl}/market_regulation_mapping/_aggrs/countries?avars={'fs_language':'${language}'}`
    )
        .then(res => res.json())
        .then(data => {
            return data._embedded['rh:result'].sort((a, b) => {
                const aa = stripUmlauts(a._id.name);
                const bb = stripUmlauts(b._id.name);

                if (aa < bb) {
                    return -1;
                } else {
                    return 1;
                }
            });
        });
}

export async function fetchComponents(apiBaseUrl: string, language: string, countryId: number): Promise<[]> {
    return await fetch(
        `${apiBaseUrl}/market_regulation_mapping/_aggrs/components_by_country?avars={'country':${countryId},'fs_language':'${language}'}`
    )
        .then(res => res.json())
        .then(data => {
            return data._embedded['rh:result'];
        });
}

export async function fetchRegulations(
    apiBaseUrl: string,
    language: string,
    countryId: number,
    componentId: number
): Promise<[]> {
    return await fetch(
        `${apiBaseUrl}/market_regulations?filter={'$and':[{'countries':${countryId}},{'components':${componentId}},{'fs_language':'${language}'},{'visible':true}]}&keys={'shortTitle':1}`
    )
        .then(res => res.json())
        .then(data => {
            return data._embedded['rh:doc'];
        });
}
